import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from "@angular/core";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { map, takeUntil } from "rxjs";
import { FormControlService } from "../form-control.service";
import { ControlValueAccessorImpl } from "../ng-material-impl/control-value-accessor.impl";
import createControlValueAccessorProvider from "../utils/create-control-value-accessor-provider";
import { SliderFormControlService } from "./slider-form-control.service";


@Component({
  selector: 'ss-slider-form-control',
  templateUrl: './slider-form-control.component.html',
  styleUrls: ['./slider-form-control.component.css'],
  providers: [
    FormControlService,
    SliderFormControlService,
    createControlValueAccessorProvider(SliderFormControlComponent)
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SliderFormControlComponent extends ControlValueAccessorImpl<boolean> implements OnInit {


  readonly labelObs = this._formControlService.labelObs;

  @ViewChild('slideToggleRef')
  private _slideToggleRef!: MatSlideToggle

  constructor(
  ) {

    super()
  }

  ngOnInit(): void {


  }

  ngAfterViewInit() {
    this._formControlService.htmlElementSubject.next(this._slideToggleRef._elementRef.nativeElement);

    this._slideToggleRef.change
      .pipe(
        takeUntil(this._destroy),
        map(({ checked }) => checked)
      )
      .subscribe((value) => {
        this.value = value;
      })
  }

  ngOnDestroy() {
    this._destroy.next();
    this._destroy.complete();

  }
}
